var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect4, _rect5, _rect6, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect7, _rect8, _rect9, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _rect10, _rect11, _rect12, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _ellipse, _ellipse2, _path49, _ellipse3, _ellipse4, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerSupplyLeads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 91,
    fill: "none",
    viewBox: "0 0 29 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.871,
    height: 6.096,
    x: 5.997,
    y: 77.067,
    fill: "#000",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.435,
    height: 6.096,
    x: 6.715,
    y: 71.842,
    fill: "#000",
    rx: 0.718
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.153,
    height: 1.306,
    x: 6.355,
    y: 71.842,
    fill: "#000",
    rx: 0.653
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9603",
    d: "M6.355 83.163H8.508000000000001V83.598H6.355z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7CF7A",
    d: "M6.355 83.163H7.073V83.598H6.355z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#866800",
    d: "M7.791 83.163H8.509V83.598H7.791z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.715 86.646H8.15V87.081H6.715zM6.715 87.517H8.15V87.952H6.715z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9603",
    fillRule: "evenodd",
    d: "M6.715 83.598H8.15v3.048H6.715v-3.048zm0 3.483H8.15v.436H6.715v-.436zm1.435.871H6.715v.436H8.15v-.436z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#866800",
    fillRule: "evenodd",
    d: "M7.791 83.598h.359v3.048H7.79v-3.048zm0 3.483h.359v.436H7.79v-.436zm.359.871H7.79v.436h.359v-.436z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7CF7A",
    fillRule: "evenodd",
    d: "M6.715 83.598h.359v3.048h-.36v-3.048zm0 3.483h.359v.436h-.36v-.436zm.359.871h-.36v.436h.36v-.436z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9603",
    d: "M7.073 88.388h.718v2.177L7.432 91l-.359-.435v-2.177z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#866800",
    d: "M7.433 88.388h.358v2.177L7.433 91v-2.612z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.871,
    height: 6.096,
    x: 0.803,
    y: 77.067,
    fill: "#AD210C",
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.435,
    height: 6.096,
    x: 1.521,
    y: 71.842,
    fill: "#AD210C",
    rx: 0.718
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.153,
    height: 1.306,
    x: 1.161,
    y: 71.842,
    fill: "#AD210C",
    rx: 0.653
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9603",
    d: "M1.161 83.163H3.314V83.598H1.161z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7CF7A",
    d: "M1.161 83.163H1.879V83.598H1.161z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#866800",
    d: "M2.597 83.163H3.315V83.598H2.597z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M1.521 86.646H2.956V87.081H1.521zM1.521 87.517H2.956V87.952H1.521z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9603",
    fillRule: "evenodd",
    d: "M1.52 83.598h1.436v3.048H1.521v-3.048zm0 3.483h1.436v.436H1.521v-.436zm1.436.871H1.521v.436h1.435v-.436z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#866800",
    fillRule: "evenodd",
    d: "M2.597 83.598h.359v3.048h-.36v-3.048zm0 3.483h.359v.436h-.36v-.436zm.359.871h-.36v.436h.36v-.436z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7CF7A",
    fillRule: "evenodd",
    d: "M1.52 83.598h.36v3.048h-.36v-3.048zm0 3.483h.36v.436h-.36v-.436zm.36.871h-.36v.436h.36v-.436z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9603",
    d: "M1.879 88.388h.718v2.177l-.36.435-.358-.435v-2.177z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#866800",
    d: "M2.238 88.388h.36v2.177l-.36.435v-2.612z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2.871,
    height: 6.096,
    x: 19.848,
    y: 77.067,
    fill: "#000",
    rx: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 1.435,
    height: 6.096,
    x: 20.565,
    y: 71.842,
    fill: "#000",
    rx: 0.718
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 2.153,
    height: 1.306,
    x: 20.206,
    y: 71.842,
    fill: "#000",
    rx: 0.653
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9603",
    d: "M20.206 83.163H22.358999999999998V83.598H20.206z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7CF7A",
    d: "M20.206 83.163H20.924V83.598H20.206z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#866800",
    d: "M21.642 83.163H22.36V83.598H21.642z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.565 86.646H22V87.081H20.565zM20.565 87.517H22V87.952H20.565z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9603",
    fillRule: "evenodd",
    d: "M20.565 83.598h1.436v3.048h-1.436v-3.048zm0 3.483h1.436v.436h-1.436v-.436zm1.436.871h-1.436v.436h1.436v-.436z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#866800",
    fillRule: "evenodd",
    d: "M21.642 83.598H22v3.048h-.358v-3.048zm0 3.483H22v.436h-.358v-.436zm.358.871h-.358v.436H22v-.436z",
    clipRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7CF7A",
    fillRule: "evenodd",
    d: "M20.565 83.598h.36v3.048h-.36v-3.048zm0 3.483h.36v.436h-.36v-.436zm.36.871h-.36v.436h.36v-.436z",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9603",
    d: "M20.924 88.388h.718v2.177l-.36.435-.358-.435v-2.177z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#866800",
    d: "M21.283 88.388h.36v2.177l-.36.435v-2.612z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 2.871,
    height: 6.096,
    x: 25.042,
    y: 77.067,
    fill: "#AD210C",
    rx: 1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 1.435,
    height: 6.096,
    x: 25.76,
    y: 71.842,
    fill: "#AD210C",
    rx: 0.718
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 2.153,
    height: 1.306,
    x: 25.4,
    y: 71.842,
    fill: "#AD210C",
    rx: 0.653
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9603",
    d: "M25.4 83.163H27.552999999999997V83.598H25.4z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7CF7A",
    d: "M25.4 83.163H26.118V83.598H25.4z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#866800",
    d: "M26.836 83.163H27.554V83.598H26.836z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M25.76 86.646H27.195V87.081H25.76zM25.76 87.517H27.195V87.952H25.76z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9603",
    fillRule: "evenodd",
    d: "M25.76 83.598h1.435v3.048H25.76v-3.048zm0 3.483h1.435v.436H25.76v-.436zm1.435.871H25.76v.436h1.435v-.436z",
    clipRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#866800",
    fillRule: "evenodd",
    d: "M26.836 83.598h.359v3.048h-.36v-3.048zm0 3.483h.359v.436h-.36v-.436zm.359.871h-.36v.436h.36v-.436z",
    clipRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7CF7A",
    fillRule: "evenodd",
    d: "M25.76 83.598h.359v3.048h-.36v-3.048zm0 3.483h.359v.436h-.36v-.436zm.359.871h-.36v.436h.36v-.436z",
    clipRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9603",
    d: "M26.118 88.388h.718v2.177l-.359.435-.359-.435v-2.177z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#866800",
    d: "M26.477 88.388h.36v2.177l-.36.435v-2.612z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    d: "M15.952 23.512c9.306 1.306 5.362 33.526 5.362 48.33"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    stroke: "#AD210C",
    strokeWidth: 2,
    d: "M15.153 23.512c8.95 0 11.548 33.526 11.548 48.33"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    d: "M12.85 23.512c-9.307 1.306-5.362 33.526-5.362 48.33"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    stroke: "#AD210C",
    strokeWidth: 2,
    d: "M13.648 23.512c-8.95 0-11.547 33.526-11.547 48.33"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.477 55.279c2.246-2.97 3.92-7.31 4.375-12.325.455-5.015-.408-9.59-2.082-12.919-1.686-3.354-4.047-5.207-6.53-5.435-2.484-.228-5.14 1.164-7.402 4.155-2.246 2.969-3.92 7.31-4.375 12.325-.455 5.015.409 9.59 2.082 12.918 1.687 3.355 4.047 5.207 6.53 5.436 2.484.228 5.14-1.164 7.402-4.155zm-7.559 5.89c6.583.604 12.697-7.48 13.658-18.057.96-10.577-3.597-19.641-10.18-20.246C8.816 22.26 2.7 30.345 1.74 40.922.78 51.499 5.336 60.563 11.92 61.168z",
    clipRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD210C",
    fillRule: "evenodd",
    d: "M23.122 54.186c1.729-3.3 2.669-7.86 2.298-12.881-.372-5.022-1.972-9.391-4.167-12.398-2.212-3.03-4.844-4.466-7.331-4.28-2.487.186-4.879 1.999-6.621 5.324-1.73 3.3-2.67 7.86-2.298 12.881.371 5.022 1.971 9.39 4.167 12.397 2.212 3.03 4.844 4.467 7.33 4.28 2.488-.186 4.879-1.998 6.622-5.323zm-6.493 7.06c6.592-.493 11.3-9.479 10.517-20.07-.783-10.592-6.761-18.779-13.353-18.286-6.591.494-11.3 9.48-10.517 20.071.783 10.592 6.761 18.778 13.353 18.285z",
    clipRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD210C",
    fillRule: "evenodd",
    d: "M23.61 51.963c1.729-3.067 2.682-7.297 2.338-11.952-.345-4.655-1.91-8.697-4.07-11.473-2.17-2.787-4.794-4.147-7.336-3.957-2.542.19-4.938 1.926-6.673 5.005-1.73 3.067-2.682 7.297-2.338 11.952.344 4.655 1.909 8.697 4.07 11.473 2.169 2.787 4.793 4.147 7.335 3.957 2.543-.19 4.938-1.926 6.674-5.005zm-6.545 6.742c6.591-.493 11.341-8.92 10.61-18.823-.733-9.903-6.67-17.531-13.261-17.038-6.592.493-11.342 8.92-10.61 18.823.732 9.903 6.67 17.531 13.26 17.038z",
    clipRule: "evenodd"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.323 53.167c2.207-2.74 3.839-6.754 4.261-11.402.422-4.648-.46-8.894-2.137-11.99-1.684-3.109-4.05-4.885-6.588-5.118-2.54-.233-5.186 1.082-7.402 3.832-2.207 2.74-3.84 6.754-4.261 11.402-.422 4.648.46 8.894 2.137 11.99 1.683 3.109 4.05 4.885 6.588 5.118 2.539.233 5.186-1.082 7.402-3.832zm-7.56 5.566c6.583.605 12.647-6.92 13.545-16.81.898-9.889-3.71-18.396-10.292-19-6.582-.605-12.646 6.92-13.545 16.81-.898 9.889 3.71 18.396 10.293 19z",
    clipRule: "evenodd"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD210C",
    fillRule: "evenodd",
    d: "M23.466 49.51c1.727-2.807 2.691-6.665 2.378-10.902-.313-4.237-1.834-7.91-3.955-10.43-2.121-2.52-4.74-3.792-7.347-3.597-2.606.195-5.01 1.842-6.738 4.651-1.726 2.808-2.69 6.666-2.377 10.903.313 4.237 1.834 7.91 3.954 10.429 2.122 2.521 4.741 3.793 7.348 3.598 2.606-.195 5.01-1.843 6.737-4.652zM16.857 55.9c6.592-.493 11.388-8.293 10.713-17.42-.674-9.128-6.565-16.128-13.156-15.635-6.592.493-11.388 8.292-10.714 17.42.675 9.128 6.566 16.128 13.157 15.635z",
    clipRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.582 50.724c2.163-2.483 3.745-6.13 4.13-10.36.384-4.232-.516-8.106-2.195-10.942-1.68-2.838-4.056-4.526-6.659-4.765-2.602-.24-5.242.988-7.406 3.473-2.162 2.483-3.745 6.129-4.13 10.36-.383 4.231.516 8.105 2.195 10.941 1.68 2.838 4.056 4.526 6.659 4.766 2.602.239 5.243-.988 7.406-3.473zm-7.564 5.207c6.583.605 12.59-6.294 13.418-15.41.827-9.114-3.838-16.994-10.42-17.599-6.582-.605-12.59 6.294-13.417 15.41-.828 9.114 3.837 16.994 10.42 17.599z",
    clipRule: "evenodd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#99B2C4",
    d: "M11.185 4.112c0-2.271 1.84-4.112 4.112-4.112 2.27 0 4.112 1.841 4.112 4.112v9.434c0 1.656-1.343 3-3 3h-2.224c-1.657 0-3-1.344-3-3V4.112z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#99B2C4",
    d: "M13.781 16.545H16.811V24.818H13.781z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.296,
    cy: 4.878,
    fill: "#668BA6",
    rx: 1.959,
    ry: 1.948,
    transform: "rotate(-90 15.296 4.878)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.296,
    cy: 4.571,
    fill: "#DDD",
    rx: 1.959,
    ry: 1.948,
    transform: "rotate(-90 15.296 4.571)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    fillRule: "evenodd",
    d: "M14.195 4.645l.112.418.835-.226.225.842.418-.114-.224-.841.836-.226-.111-.419-.836.227-.224-.842-.419.113.224.842-.836.226z",
    clipRule: "evenodd"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.296,
    cy: 11.409,
    fill: "#668BA6",
    rx: 1.959,
    ry: 1.948,
    transform: "rotate(-90 15.296 11.409)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.296,
    cy: 11.103,
    fill: "#DDD",
    rx: 1.959,
    ry: 1.948,
    transform: "rotate(-90 15.296 11.103)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    fillRule: "evenodd",
    d: "M14.944 10.051l-.376.219.433.754-.75.436.217.375.75-.435.432.754.376-.218-.433-.754.75-.436-.217-.376-.75.436-.432-.755z",
    clipRule: "evenodd"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#99B2C4",
    d: "M13.782 18.287c0-1.393-.938-1.597-1.515-1.742l1.731-.435 1.082 1.306c-.36 1.016-1.298 2.264-1.298.87zM16.811 18.287c0-1.393.938-1.597 1.515-1.742l-1.731-.435-1.082 1.306c.36 1.016 1.298 2.264 1.298.87z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#668BA6",
    d: "M17.678 0c.956 0 1.731.775 1.731 1.731v13.083c0 .956-.775 1.732-1.731 1.732V0zM15.946 16.545H16.812V24.818H15.946z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#668BA6",
    d: "M18.327 16.545c-1.027.345-1.515.871-1.515 1.742h-.866V16.11c0-.653 1.732-.435 1.732-1.306.684.123 1.415 1.484.649 1.741z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.617 1.741c0-.435.433-.87.433-.87V16.109s-.433-.435-.433-.87V1.741z",
    opacity: 0.3
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.84 55.714c2.246-2.969 3.92-7.31 4.375-12.325.456-5.015-.408-9.59-2.082-12.918-1.686-3.355-4.047-5.207-6.53-5.436-2.484-.228-5.14 1.164-7.402 4.155-2.246 2.969-3.919 7.31-4.374 12.325-.456 5.015.408 9.59 2.081 12.918 1.687 3.355 4.048 5.208 6.531 5.436 2.484.228 5.139-1.164 7.402-4.155zm-7.558 5.89c6.582.604 12.697-7.48 13.657-18.057.96-10.577-3.596-19.641-10.179-20.246-6.582-.605-12.697 7.479-13.658 18.056-.96 10.577 3.597 19.641 10.18 20.246z",
    clipRule: "evenodd"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD210C",
    fillRule: "evenodd",
    d: "M23.485 54.62c1.73-3.3 2.67-7.858 2.298-12.88-.371-5.022-1.972-9.391-4.167-12.398-2.212-3.03-4.844-4.466-7.33-4.28-2.488.186-4.88 1.999-6.622 5.324-1.729 3.3-2.67 7.86-2.298 12.881.371 5.022 1.972 9.391 4.167 12.397 2.212 3.03 4.844 4.466 7.33 4.28 2.488-.186 4.88-1.998 6.622-5.323zm-6.493 7.061c6.592-.493 11.3-9.479 10.518-20.07-.783-10.592-6.762-18.779-13.353-18.285-6.592.492-11.3 9.478-10.518 20.07.783 10.592 6.762 18.778 13.353 18.285z",
    clipRule: "evenodd"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD210C",
    fillRule: "evenodd",
    d: "M23.973 52.398c1.729-3.067 2.682-7.297 2.338-11.952-.344-4.655-1.909-8.696-4.07-11.473-2.17-2.787-4.793-4.147-7.336-3.957-2.542.19-4.937 1.926-6.673 5.005-1.729 3.067-2.682 7.297-2.338 11.952.344 4.655 1.909 8.697 4.07 11.473 2.169 2.787 4.793 4.148 7.336 3.957 2.542-.19 4.937-1.925 6.673-5.005zm-6.545 6.742c6.591-.493 11.342-8.92 10.61-18.823-.733-9.903-6.67-17.531-13.261-17.038-6.592.493-11.342 8.92-10.61 18.823.732 9.903 6.67 17.531 13.261 17.038z",
    clipRule: "evenodd"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.686 51.425c2.207-2.739 3.84-6.754 4.261-11.402.422-4.648-.46-8.894-2.137-11.99-1.683-3.108-4.05-4.885-6.588-5.118-2.539-.233-5.186 1.082-7.401 3.832-2.208 2.74-3.84 6.754-4.262 11.402-.422 4.649.46 8.894 2.137 11.99 1.684 3.109 4.05 4.885 6.588 5.118 2.54.234 5.186-1.082 7.402-3.832zm-7.559 5.567c6.582.605 12.646-6.921 13.545-16.81.898-9.89-3.71-18.396-10.293-19.001-6.582-.605-12.646 6.921-13.544 16.81-.898 9.889 3.71 18.396 10.292 19z",
    clipRule: "evenodd"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD210C",
    fillRule: "evenodd",
    d: "M23.83 49.075c1.726-2.807 2.69-6.666 2.377-10.903-.313-4.237-1.834-7.91-3.954-10.429-2.122-2.521-4.741-3.793-7.348-3.598-2.606.195-5.01 1.843-6.737 4.652-1.727 2.807-2.691 6.665-2.378 10.902.313 4.238 1.835 7.91 3.955 10.43 2.121 2.52 4.74 3.792 7.347 3.597 2.607-.195 5.01-1.842 6.738-4.651zm-6.61 6.388c6.592-.493 11.389-8.292 10.714-17.42-.675-9.128-6.566-16.128-13.157-15.634-6.592.493-11.388 8.292-10.713 17.42.674 9.127 6.565 16.127 13.157 15.634z",
    clipRule: "evenodd"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.946 51.159c2.162-2.483 3.744-6.13 4.129-10.36.384-4.232-.516-8.106-2.195-10.942-1.68-2.838-4.055-4.526-6.658-4.765-2.603-.24-5.243.988-7.407 3.473-2.162 2.483-3.744 6.129-4.129 10.36-.384 4.231.515 8.105 2.195 10.941 1.68 2.838 4.055 4.526 6.658 4.766 2.603.239 5.243-.988 7.407-3.473zm-7.565 5.207c6.583.605 12.59-6.294 13.418-15.409.828-9.115-3.837-16.995-10.42-17.6-6.582-.604-12.59 6.294-13.417 15.41-.828 9.114 3.837 16.994 10.42 17.599z",
    clipRule: "evenodd"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#99B2C4",
    fillRule: "evenodd",
    d: "M16.811 21.671c.271-.449.433-1.02.433-1.642 0-1.443-.872-2.613-1.948-2.613-1.075 0-1.947 1.17-1.947 2.613 0 .622.162 1.193.432 1.642v4.245c0 .837.679 1.515 1.515 1.515.837 0 1.515-.678 1.515-1.515V21.67z",
    clipRule: "evenodd"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD8E1",
    fillRule: "evenodd",
    d: "M16.811 21.671c.271-.449.433-1.02.433-1.642 0-1.443-.872-2.613-1.948-2.613-1.075 0-1.947 1.17-1.947 2.613 0 .622.162 1.193.432 1.642v4.245c0 .837.679 1.515 1.515 1.515.837 0 1.515-.678 1.515-1.515V21.67z",
    clipRule: "evenodd"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#99B2C4",
    d: "M15.513 22.641l1.298-.87v4.361c0 .717-.581 1.299-1.298 1.299v-4.79z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#99B2C4",
    d: "M17.46 20.029c0 1.443-.872 2.612-1.947 2.612 0 0 1.082-1.17 1.082-2.612 0-1.443-1.082-2.613-1.082-2.613 1.075 0 1.947 1.17 1.947 2.613z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15.08 17.852c-.65.435-1.298 2.286-.217 4.79-.06-.082-.12-.16-.177-.236l-.04-.051v4.64s-.432-.435-.432-.87v-4.383c-.272-.445-.433-.917-.433-1.713 0-.87.65-1.96 1.299-2.177z",
    clipRule: "evenodd",
    opacity: 0.3
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.3,
    d: "M16.811 25.471v-.653c.938.218 3.333 1.176 5.411 3.266 2.078 2.09 2.741 6.821 2.814 8.926-.722-1.814-2.31-6.146-3.896-8.273-1.299-1.742-3.463-3.12-4.329-3.265z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M6.856 33.09c.866-2.394 2.522-5.312 4.545-6.748-1.948-.218-2.035.914-3.247 1.96-1.212 1.044-1.947 3.628-2.164 4.789.217-.435.433-.435.866 0z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillOpacity: 0.3,
    d: "M24.733 50.942c-.433 3.484-2.655 6.023-3.809 7.185.216-.654.216-1.524-.433-1.873 0 0 2.814-1.828 4.242-5.312z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.3,
    d: "M5.34 46.806l3.464 4.79.865 1.524-.433.435-2.813-3.374-1.082-3.375zM4.908 50.29l4.112 5.007 1.299 1.306s-.65-.218-1.082 0c-.433.218-.433.87-.433.87s-1.515-1.74-2.38-3.483c-.867-1.741-1.516-3.7-1.516-3.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerSupplyLeads);
export default __webpack_public_path__ + "static/media/Power_Supply_Leads.7bf8475530bb635b100a2ac1b8b7bac4.svg";
export { ForwardRef as ReactComponent };